import { useEffect, useState } from "react";
import Scroller from "../../../utils/Scroller";
import "./Pagination.css";
import TrainingsArticle from "./TrainingsArticle/TrainingsArticle";
import hasTouch from "../../../utils/CheckTouch";
import DotsObservers from "../../../utils/DotsObservers";

let scroller: Scroller = new Scroller("trainings-scroller");
let dotsObservers: DotsObservers = new DotsObservers(
  ".training-article",
  ".trainings-articles-dot",
  "article",
  "active",
  55,
);

interface PaginationProps {
  trainings: Array<any>;
  type: string;
}

function Pagination(props: PaginationProps) {
  const [filteredTrainings, setFilteredTrainings] = useState(props.trainings);

  const [nbPages, setNbPages] = useState(0);

  const [pageIdx, setPageIdx] = useState(1);

  const [useDots, setUseDots] = useState(false);

  useEffect(() => {
    setNbPages(Math.ceil(filteredTrainings.length / 8));
  }, [filteredTrainings]);

  useEffect(() => {
    setFilteredTrainings(props.trainings);
  }, [props.trainings]);

  // eslint-disable-next-line
  useEffect(() => {
    if (!hasTouch()) {
      scroller.attachWindowResize();
    }

    if (window.innerWidth <= 767) setUseDots(true);

    return () => {
      if (scroller) scroller.detachEvents();
      if (dotsObservers) {
        dotsObservers.stopObservers();
        dotsObservers.destroyObservers();
      }
    };
  });

  useEffect(() => {
    if (useDots) {
      setObservers();
    } else {
      dotsObservers.stopObservers();
      dotsObservers.destroyObservers();
    }
  }, [useDots]);

  const getPaginationClasses = () => {
    let defaultClasses = "trainings-articles";

    if (props?.type) defaultClasses += ` ${props.type}-articles`;

    return defaultClasses;
  };

  const usePagination = () => {
    return window.innerWidth > 1024;
  };

  const nextPageClick = () => {
    if (pageIdx === nbPages) return;
    setPageIdx(pageIdx + 1);
  };

  const prevPageClick = () => {
    if (pageIdx === 1) return;
    setPageIdx(pageIdx - 1);
  };

  const setObservers = () => {
    dotsObservers.destroyObservers();
    dotsObservers.createObservers();
    dotsObservers.startObservers();
  };

  return (
    <section className={getPaginationClasses()}>
      <div className="trainings-articles-container" id="trainings-scroller">
        {usePagination() &&
          filteredTrainings.map((training, idx) => {
            if (idx >= (pageIdx - 1) * 8 && idx < pageIdx * 8)
              return (
                <TrainingsArticle training={training} key={idx} index={idx} />
              );
            else return null;
          })}
        {!usePagination() &&
          filteredTrainings.map((training, idx) => {
            return (
              <TrainingsArticle training={training} key={idx} index={idx} />
            );
          })}
      </div>
      <div className="trainings-articles-nav">
        <button
          type="button"
          className="trainings-articles-nav-btn trainings-articles-nav-previous"
          onClick={prevPageClick}
          disabled={pageIdx === 1}
        >
          <span>Précédent</span>
        </button>
        <button
          type="button"
          className="trainings-articles-nav-btn trainings-articles-nav-next"
          onClick={nextPageClick}
          disabled={pageIdx === nbPages}
        >
          <span>Suivant</span>
        </button>
      </div>
      <div className="trainings-articles-dots">
        {filteredTrainings.map((training, idx) => {
          return <div className="trainings-articles-dot" key={idx}></div>;
        })}
      </div>
    </section>
  );
}

export default Pagination;
